import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const features = [
  {
    title: 'High-Performance Architecture',
    desc: 'Systems designed for global scale. Sub-millisecond latency, zero single points of failure, built for relentless traffic.',
    stat: '99.99%',
    label: 'Uptime SLA',
  },
  {
    title: 'AI-First Engineering',
    desc: 'Neural integrations built directly into the core operational layer — not bolted on, but engineered from the ground up.',
    stat: '10×',
    label: 'Processing Speed',
  },
  {
    title: 'Elastic Cloud Systems',
    desc: 'Auto-scaling infrastructure ensuring zero downtime during traffic spikes. From 10 users to 10 million, seamlessly.',
    stat: '∞',
    label: 'Horizontal Scale',
  },
  {
    title: 'Enterprise-Grade Security',
    desc: 'Bank-level encryption, penetration testing, and zero-trust security practices baked in from the very first line of code.',
    stat: 'Zero',
    label: 'Breaches',
  },
];

const Features = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="section features-section" id="features" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={visible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="section-label">Why Us</p>
          <h2 className="section-title">
            The Physics of<br />
            <span className="muted">Software.</span>
          </h2>
        </motion.div>

        <div className="features-grid">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              className="feature-card"
              initial={{ opacity: 0, y: 40 }}
              animate={visible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.1 * i, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="feature-text">
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
              <div className="feature-stat">
                <span className="feature-stat-value">{f.stat}</span>
                <span className="feature-stat-label">{f.label}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
